// The three things every list has to say besides showing rows.

export function Loading({ label = 'Loading…' }) {
  return (
    <div role="status" className="py-10 text-center text-ink-3 text-body-s">
      {label}
    </div>
  )
}

// An empty list invites an action rather than reporting a count of zero, so
// `action` is the point of this component and the copy above it is the setup.
export function Empty({ title, note, action }) {
  return (
    <div className="py-12 text-center">
      <p className="text-body font-semibold text-ink">{title}</p>
      {note && <p className="text-body-s text-ink-3 mt-1.5 max-w-[42ch] mx-auto">{note}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  )
}

export function Failed({ error, onRetry }) {
  return (
    <div role="alert" className="py-12 text-center">
      <p className="text-body font-semibold text-ink">Something went wrong</p>
      <p className="text-body-s text-ink-3 mt-1.5">{error?.message ?? 'Please try again.'}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-5 text-body-s font-semibold text-brand underline underline-offset-4"
        >
          Try again
        </button>
      )}
    </div>
  )
}

// Rows, not cards — the lists these stand in for are rows now, and a skeleton
// that does not match its content is just a second layout shift.
export function RowSkeleton({ count = 4 }) {
  return (
    <div aria-hidden="true">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="py-4 border-b border-hairline animate-pulse">
          <div className="h-[15px] w-1/2 bg-surface-2 rounded-chip" />
          <div className="h-[13px] w-1/3 bg-surface-2 rounded-chip mt-2" />
        </div>
      ))}
    </div>
  )
}
